const ZonesSection = () => {
  const barriosElPrat = [
    'Centre',
    'Eixample',
    'Sant Cosme',
    'La Granja',
    'Jardins de la Pau',
    'Zona Delta',
    'Les Moreres',
    'Can Tries',
  ];

  const localidadesCercanas = [
    'Viladecans',
    'Gavà',
    'Sant Boi de Llobregat',
    'Cornellà de Llobregat',
    'L\'Hospitalet de Llobregat',
    'Barcelona Sur',
    'Castelldefels',
    'Esplugues de Llobregat',
  ];

  return (
    <section className="py-20 bg-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4">
            Servicio en El Prat de Llobregat y alrededores
          </h2>
          <p className="text-lg text-secondary max-w-3xl mx-auto">
            Ofrecemos <strong>vaciado de pisos</strong>, <strong>vaciado de locales</strong> y <strong>limpieza por síndrome de Diógenes</strong> en toda la comarca del Baix Llobregat
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Column - Barrios de El Prat */}
          <div className="bg-white rounded-2xl p-8 shadow-md">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                <i className="ri-map-pin-line text-2xl text-primary"></i>
              </div>
              <h3 className="text-2xl font-bold text-dark">Barrios de El Prat de Llobregat</h3>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {barriosElPrat.map((barrio, index) => (
                <div key={index} className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-primary text-xl flex-shrink-0"></i>
                  <span className="text-dark font-medium">{barrio}</span>
                </div>
              ))}
            </div>

            <div className="mt-6 p-4 bg-primary/5 rounded-lg">
              <p className="text-sm text-dark/80 leading-relaxed">
                <strong>Servicio completo en todos los barrios de El Prat:</strong> Realizamos <strong>vaciado de pisos y casas</strong>, <strong>retirada de muebles</strong> y <strong>limpieza extrema</strong> en cualquier zona de la ciudad.
              </p>
            </div>
          </div>

          {/* Right Column - Localidades Cercanas */}
          <div className="bg-white rounded-2xl p-8 shadow-md">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                <i className="ri-map-2-line text-2xl text-primary"></i>
              </div>
              <h3 className="text-2xl font-bold text-dark">Localidades cercanas</h3>
            </div>

            <div className="flex flex-wrap gap-3 mb-6">
              {localidadesCercanas.map((localidad, index) => (
                <span
                  key={index}
                  className="px-4 py-2 bg-secondary/20 text-dark font-medium rounded-full text-sm hover:bg-primary hover:text-white transition-colors cursor-pointer"
                >
                  {localidad}
                </span>
              ))}
            </div>

            <div className="p-4 bg-primary/5 rounded-lg">
              <p className="text-sm text-dark/80 leading-relaxed mb-4">
                <strong>Cobertura en toda la comarca del Baix Llobregat:</strong> Nuestro equipo se desplaza a todas las localidades cercanas para ofrecer servicios de <strong>vaciado de locales comerciales</strong>, <strong>limpieza por síndrome de Diógenes</strong> y <strong>retirada de electrodomésticos</strong>.
              </p>
              <a
                href="/contacto"
                className="inline-flex items-center gap-2 text-primary font-semibold hover:gap-3 transition-all cursor-pointer"
              >
                Consultar disponibilidad en tu zona
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Map Placeholder */}
        <div className="mt-12 bg-white rounded-2xl p-8 shadow-md">
          <h3 className="text-2xl font-bold text-dark mb-6 text-center">
            Nuestra área de servicio
          </h3>
          <div className="w-full h-96 rounded-xl overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d47859.89171087!2d2.0758!3d41.3275!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a4992f3d6b7c8b%3A0x402359b7f3b3d60!2sEl%20Prat%20de%20Llobregat%2C%20Barcelona!5e0!3m2!1ses!2ses!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Mapa de El Prat de Llobregat"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ZonesSection;
